import React from 'react';
import { JBTypography } from '@jbhi-fi/lanyard-ui';
import { JBLogo } from '@jbhi-fi/lanyard-ui/components/Icons';
import LoadingComponent from './components/loading.component';

const ReceiptLayout = ({ children, wide, ripped, isLoading }) => {
  return (
    <>
      <div className={`container ${wide ? 'wide' : ''} ${ripped ? 'ripped' : ''}`}>
        <JBLogo className="logo" />
        <div className="logo-receipts">
          <JBTypography type="h3" font="dom_casual" align="center" margin="0px">
            DIGITAL RECEIPT
          </JBTypography>
        </div>
        <div className="body">
          {isLoading ? (
            <div className="primary-block">
              <LoadingComponent />
            </div>
          ) : (
            children
          )}
        </div>
      </div>
    </>
  );
};

export default ReceiptLayout;
